module.exports = __webpack_public_path__ + "static/media/rw-logo-with-text-large.c97d3031.svg";